import {InputNumber, Modal, Row, Col} from 'antd';
import {useState} from "react";
import {DatePickerWidget} from "../widget/DatePickerWidget";
import * as dayjs from "dayjs";

export const MetricValueAdjust = ({value, date, minDate, onAdjust, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [adjustment, setAdjustment] = useState(value);

    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const [displayDate, setDisplayDate] = useState(dayjs(new Date(date)).toString());

    const onOpen = () => {
        setAdjustment(value);
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onAdjust) {
            onAdjust(adjustment, displayDate);
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (val) => {
        if (val) {
            setAdjustment(val);
        } else {
            setAdjustment(0);
        }
    }

    const onDateChange = (dateString, dateJs) => {
        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    return <div>
        <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
        <Modal title={<b>Override Recorded Value</b>} width={400} open={isOpen} onOk={onOk} onCancel={onCancel}>
            <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><InputNumber style={{width: 300}} precision={0} onChange={onInputChange} value={adjustment}  /></Col>
            </Row>
            <Row>
                <DatePickerWidget date={displayDate} onChange={onDateChange} minDate={minDate} maxDate={new Date()} />
            </Row>
        </Modal>
    </div>
}